import authenticationMiddleware from './authenticationMiddleware'
// import loggerMiddleware from './loggerMiddleware';

// Export as an array if you prefer to apply them all at once
export const middlewares = [authenticationMiddleware] // [loggerMiddleware, authenticationMiddleware]

// Or export individually for selective use
export { applyMiddleware } from './applyMiddleware'
